import { useUIVerification } from '~/composables/Verification/useUIVerification';

/**
 * Whether the profile is a consumer student's, so it asks for a birthday. School students are not
 * asked for one: their school places them by year level.
 */
export const useIsConsumerProfile = () => {
  const { schoolStudentRoles } = useAuth();
  const config = useConfigStore();

  return computed(() => !config.isSchoolsCluster && schoolStudentRoles.value.length === 0);
};

/** Whether the profile offers the phone field: phone verification writes to the global student role, so only a student with one can add a phone. */
export const useCanVerifyPhone = () => {
  const { globalStudentRole } = useAuth();

  return computed(() => !!globalStudentRole.value);
};

/** Who the signed-in student is, as the profile page shows it: name, contact details and where they live. */
export const useProfileIdentity = () => {
  const { user, accountStudentRole } = useAuth();
  const { isPhoneVerified } = useUIVerification();

  const firstName = computed(() => accountStudentRole.value?.firstName ?? '');
  const lastName = computed(() => accountStudentRole.value?.lastName ?? '');
  const fullName = computed(() => [firstName.value, lastName.value].filter(Boolean).join(' '));
  const email = computed(() => user.value?.primaryEmail ?? '');
  const phoneNumber = computed(() => accountStudentRole.value?.phoneNumber ?? '');
  const stateName = computed(() => accountStudentRole.value?.state?.name ?? '');
  const birthDate = computed(() => accountStudentRole.value?.birthDate ?? null);
  const isConsumerProfile = useIsConsumerProfile();
  const canVerifyPhone = useCanVerifyPhone();

  return { firstName, lastName, fullName, email, phoneNumber, isPhoneVerified, stateName, birthDate, isConsumerProfile, canVerifyPhone };
};
